// extracted by mini-css-extract-plugin
module.exports = {"button":"skins-smallOnWide-button-d08eff0b","buttonLoading":"skins-smallOnWide-buttonLoading-c0b226db"};